'use strict';

DoohApps
.directive('slideToggle', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var target = document.querySelector(attrs.slideToggle);
            attrs.expanded = false;
            element.bind('click', function () {
                $(target).slideToggle('slow', function () {
                });
            });
        }
    };
});